import { useMemo } from 'react';

import { useEcomPlatform } from 'utils/hooks';
import { SERVICE_WINDOW_START_OPTIONS } from '../stubs';

export default function useServiceWindowStartOptions() {
  const { checkIfPlatformIs } = useEcomPlatform();

  const isBigcommerce = checkIfPlatformIs('BIGCOMMERCE');

  return useMemo(() => {
    if (!isBigcommerce) return SERVICE_WINDOW_START_OPTIONS;
    return SERVICE_WINDOW_START_OPTIONS.filter(({ value }) => !value);
  }, [isBigcommerce]);
}
